


































































import Vue from 'vue';
import { post, ENDPOINTS } from '@/api/mainApi';
import { DonationCertificate } from '@/interfaces/donation/certificate/donationCertificate';

export default Vue.extend({
  name: 'CertificatePreview',
  props: {
    value: { type: Boolean, required: true },
    imageId: { type: Number,  required: true },
    subjectName: { type: String,  required: true },
    donationCauseId: { type: Number, required: true },
    message: { type: String,  default: '' },
    donorNames: { type: String,  default: '' },
  },
  data() {
    return {
      internalVisible: this.value,
      loading: false,
      showErrorMessage: false,
      src: '',
      lastStamp: '',
      errorCount: 0,
      maxErrors: 3
    };
  },
  watch: {
    value(v: boolean) {
      this.internalVisible = v;
    },
    internalVisible(v: boolean) {
      if (v && this.payloadStamp !== this.lastStamp) {
        this.fetch();
      }
    },
    payloadStamp(newStamp: string, oldStamp: string) {
      if (this.internalVisible && newStamp !== oldStamp) {
        this.fetch();
      }
    }
  },
  computed: {
    payloadStamp(): string {
      return JSON.stringify({
        imageId: this.imageId,
        subjectName: this.subjectName,
        donationCauseId: this.donationCauseId,
        message: this.message,
        donorNames: this.donorNames,
      });
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      this.showErrorMessage = false;
      this.lastStamp = this.payloadStamp;
      const payload: DonationCertificate = {
        imageId: this.imageId,
        deceasedName: this.subjectName,
        donationCauseId: this.donationCauseId,
        message: this.message,
        donorNames: this.donorNames,
        source: '',
      };
      try {
        const res = await post(`${ENDPOINTS.DONATIONS}/${ENDPOINTS.CERTIFICATE}`, payload);
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.src = res.donationCertificate.source + '?asImage=true';
          });
        });
      } catch {
        this.showErrorMessage = true;
        this.loading = false;
      }
    },
    onLoad() {
      this.loading = false;
      this.errorCount = 0;
    },
    onError() {
      this.loading = false;
      this.errorCount++;
      if (this.errorCount <= this.maxErrors) {
        // issues may appear with multiple fast activations (still processing image, while new request is made)
        console.error("Error occured. Will perform another attempt");
        this.fetch();
      } else {
        this.showErrorMessage = true;
      }
    },
  }
});
